import { useEffect, useState } from "react";
import { PenLine, Table2 } from "lucide-react";
import { api } from "@/lib/api";
import { MAX_ITEMS, toText } from "@/lib/proposal";
import { ItemRows, ghostBtn } from "./ItemRows";
import { TradeTablePicker } from "./TradeTablePicker";

// "Aparelho na troca": valor digitado à mão ou calculado pela tabela (e ajustável depois).
export const ProposalTrade = ({ items, onChange }) => {
  const [table, setTable] = useState(false);
  const [prices, setPrices] = useState([]);
  const [bonus, setBonus] = useState(0);
  useEffect(() => {
    api.get("/trade-prices").then((r) => setPrices(Array.isArray(r?.data) ? r.data : [])).catch(() => setPrices([]));
    api.get("/trade-bonus").then((r) => setBonus(Number(r?.data?.amount) || 0)).catch(() => setBonus(0));
  }, []);
  const full = items.length >= MAX_ITEMS;
  const add = ({ label, value }) => {
    onChange([...items, { label, value: toText(value), source: "tabela" }]);
    setTable(false);
  };
  return (
    <div data-testid="proposal-trade">
      <p className="text-sm font-semibold text-white">Aparelho do cliente na troca <span className="font-normal text-zinc-400">(opcional)</span></p>
      <ItemRows items={items} valueKey="value" onChange={onChange} testid="proposal-trade" placeholder="Ex: iPhone 13 128GB · bateria 85%" />
      {table && <TradeTablePicker prices={prices} bonus={bonus} onAdd={add} />}
      <div className="mt-3 flex flex-wrap gap-2">
        <button type="button" data-testid="proposal-add-trade-table" disabled={full} onClick={() => setTable((v) => !v)} className={ghostBtn}><Table2 className="h-3.5 w-3.5" /> {table ? "Fechar tabela" : "Pela tabela"}</button>
        <button type="button" data-testid="proposal-add-trade-manual" disabled={full} onClick={() => onChange([...items, { label: "", value: "", source: "manual" }])} className={ghostBtn}><PenLine className="h-3.5 w-3.5" /> Digitar à mão</button>
      </div>
    </div>
  );
};
